export default "__VITE_ASSET__BkeUg2YT__"